import {Form} from 'antd';
import {FormInstance} from 'antd/es/form';
import React from 'react';

import {EReportConfigurationFormName} from 'components/report-configuration/report-configuration.constants';

import {TTableHeaderStructure} from '../excel-header-structure-loader-modal.types';
import {HeaderTreeMapperNode} from './header-tree-mapper-node/header-tree-mapper-node';

interface IHeaderTreeMapperProps {
    form: FormInstance;
    tree: TTableHeaderStructure | undefined;
}

export const HeaderTreeMapper = ({form, tree}: IHeaderTreeMapperProps) => (
    <div className="header-tree-mapper">
        <Form
            className="header-tree-mapper__form"
            form={form}
            name={EReportConfigurationFormName.EXCEL_TABLE_HEADER_STRUCTURE_LOADER}
        >
            {tree?.map(node => (
                <HeaderTreeMapperNode
                    key={node.key}
                    node={node}
                />
            ))}
        </Form>
    </div>
);
